import React from 'react';

export const TypescriptLogo = ({ className = '', deviceDisplay }) => {
  return (
    <svg
      className={className}
      width="57"
      height="57"
      fill="none"
      viewBox="0 0 512 512"
      xmlns="http://www.w3.org/2000/svg"
      css={{ transform: deviceDisplay === 'isDesktop' ? 'scale(2)' : 'scale(1.5)' }}
    >
      <rect width="520" height="520" rx="50" fill="#ffffff" />
      <path
        d="m317 407v50c8.1 4.2 18 7.3 29 9.4s23 3.1 35 3.1c12 0 23-1.1 34-3.4 11-2.3 20-6.1 28-11 8.1-5.3 15-12 19-21s7.1-19 7.1-32c0-9.1-1.4-17-4.1-24s-6.6-13-12-18c-5.1-5.3-11-10-18-14s-15-8.2-24-12c-6.6-2.7-12-5.3-18-7.9-5.2-2.6-9.7-5.2-13-7.8-3.7-2.7-6.5-5.5-8.5-8.4-2-3-3-6.3-3-10 0-3.4 0.89-6.5 2.7-9.3s4.3-5.1 7.5-7.1c3.2-2 7.2-3.5 12-4.6 4.7-1.1 9.9-1.6 16-1.6 4.2 0 8.6 0.31 13 0.94 4.6 0.63 9.3 1.6 14 2.9 4.7 1.3 9.3 2.9 14 4.9 4.4 2 8.5 4.3 12 6.9v-47c-7.6-2.9-16-5.1-25-6.5s-19-2.1-31-2.1c-12 0-23 1.3-34 3.8s-20 6.5-28 12c-8.1 5.4-14 12-19 21-4.7 8.4-7 18-7 30 0 15 4.3 28 13 38 8.6 11 22 19 39 27 6.9 2.8 13 5.6 19 8.3s11 5.5 15 8.4c4.3 2.9 7.7 6.1 10 9.5 2.5 3.4 3.8 7.4 3.8 12 0 3.2-0.78 6.2-2.3 9s-3.9 5.2-7.1 7.2-7.1 3.6-12 4.8c-4.7 1.1-10 1.7-17 1.7-11 0-22-1.9-32-5.7-11-3.8-21-9.5-30-17zm-84-123h64v-41h-179v41h64v183h51z"
        clipRule="evenodd"
        fill="#5C48D3"
        fillRule="evenodd"
      />
    </svg>
  );
};

export const ReactLogo = ({ className = '', deviceDisplay }) => {
  return (
    <svg
      className={className}
      width="62"
      height="57"
      xmlns="http://www.w3.org/2000/svg"
      css={{ transform: deviceDisplay === 'isDesktop' ? 'scale(2) translateX(6px)' : 'scale(1.6)' }}
    >
      <path
        d="M50.6414062 17.499344c-.6539062-.2169527-1.3078125-.4218525-1.9617187-.6146993.1089844-.4459583.2058594-.8919167.3027344-1.337875 1.4894531-7.183545.5085937-12.95689745-2.7972657-14.86126005C43.0003906-1.13448245 37.8054687.75782722 32.55 5.31383395c-.5207031.44595833-1.0292969.91602252-1.5136719 1.3860867-.3269531-.31337612-.6660156-.62675225-1.0050781-.92807544C24.5214844.90246235 18.9996094-1.14653538 15.69375.76988015c-3.1726563 1.83204503-4.1171875 7.26791549-2.7851563 14.06576685.1332032.6749639.2785157 1.3378749.4480469 2.0128389-.775.2169527-1.5378906.4580113-2.2523437.7111227C4.63789062 19.7894003 0 23.3088552 0 26.9488394c0 3.7605135 4.940625 7.53308 11.6613281 9.8231362.5449219.180794 1.0898438.3615879 1.646875.5182759-.1816406.7231757-.3390625 1.4342985-.484375 2.1695271-1.2714844 6.6893749-.2785156 11.9926632 2.8941406 13.8126553 3.2695313 1.8802567 8.7671875-.0482117 14.1195313-4.7126948.4238281-.3736408.8476562-.7593345 1.2714844-1.169134.5328125.5182759 1.0898437 1.0124459 1.646875 1.494563 5.1828125 4.4354775 10.3050781 6.2313637 13.465625 4.4113716 3.2695312-1.8802567 4.3351562-7.5812916 2.9546875-14.523778-.1089844-.5303289-.2300782-1.0727106-.3632813-1.6271453.3875-.1084763.7628906-.2290056 1.1382813-.3495349C56.9382812 34.4939723 62 30.7696176 62 26.9488394c0-3.6520371-4.7710938-7.1955979-11.3585938-9.4494954zM34.2574219 7.26640826c4.5046875-3.90514862 8.7066406-5.43587046 10.6199218-4.33905403 2.0464844 1.16913401 2.8335938 5.89388172 1.55 12.10113957-.0847656.4097995-.1695312.8075462-.2785156 1.2052928-2.6882812-.6026464-5.4128906-1.0365518-8.1496094-1.2776104-1.5742187-2.2418445-3.29375-4.3872657-5.1585937-6.40010466.4722656-.44595833.9324219-.8678108 1.4167969-1.28966328zM20.246875 33.204309c.6175781 1.0486047 1.2472656 2.0972094 1.9132812 3.1217083-1.8890625-.2048998-3.7660156-.506223-5.61875-.9039696.5328125-1.7356216 1.1988282-3.5315078 1.9738282-5.3635529.5570312 1.0606577 1.1261718 2.1092624 1.7316406 3.1458142zm-3.6691406-14.4996722c1.74375-.3856937 3.5964843-.6990698 5.521875-.9401284-.6417969 1.000393-1.2714844 2.0248919-1.8648438 3.0614437-.5933594 1.0244989-1.1746094 2.0731036-1.7195312 3.1337612-.7628907-1.7958862-1.4046875-3.5556137-1.9375-5.2550765zm3.3179687 8.3044673c.7992188-1.6633041 1.6710938-3.2904493 2.5914063-4.8934887.9203125-1.6030394 1.9132812-3.1578671 2.9546875-4.688589 1.8164062-.1325822 3.6691406-.2048997 5.5582031-.2048997s3.7539062.0723175 5.5582031.2048997c1.0292969 1.518669 2.0101563 3.0734966 2.9425781 4.6644831.9324219 1.5909865 1.8042969 3.2181318 2.6277344 4.8693829-.8113281 1.663304-1.6832031 3.3025022-2.615625 4.9175945-.9203125 1.6030394-1.9011719 3.1578671-2.9304687 4.7006419-1.8042969.1325822-3.68125.1928468-5.5824219.1928468s-3.7417969-.0602646-5.521875-.1687409c-1.0535156-1.5307219-2.0464844-3.0976025-2.9789063-4.7006419-.9324218-1.6030394-1.7921875-3.2301847-2.6035156-4.8934887zm21.8695313 6.171099c.6175781-1.0606576 1.1988281-2.1333682 1.7679687-3.2181317.775 1.7476745 1.453125 3.5194549 2.0464844 5.339447-1.8769531.4218525-3.778125.7472816-5.6914063.9642343.6539063-1.012446 1.2714844-2.0489978 1.8769532-3.0855496zm1.74375-9.2204898c-.5691407-1.0606576-1.1503907-2.1213153-1.7558594-3.1578671-.5933594-1.0244988-1.2109375-2.0369448-1.8527344-3.0373378 1.9496094.2410586 3.8144531.5664876 5.5582031.9642343-.5570312 1.7838333-1.2109375 3.5194549-1.9496093 5.2309706zM31.0242187 10.4001695c1.2714844 1.3740338 2.4703125 2.8203851 3.584375 4.3149482-2.3976562-.1084764-4.8074218-.1084764-7.2050781 0 1.1867188-1.5548277 2.4097656-3.0011791 3.6207031-4.3149482zm-14.046875-7.38844477c2.034375-1.18118693 6.5511719.50622297 11.3101563 4.70064186.3027344.26516441.6054687.55443468.9203125.84370495-1.8769531 2.01283896-3.6085938 4.15826016-5.1949219 6.40010466-2.7367187.2410586-5.4492187.6629111-8.1375 1.2535045-.1574219-.6146993-.290625-1.2414515-.4238281-1.8682038-1.1382813-5.83361707-.3875-10.23293574 1.5257812-11.32975217zM14.0105469 34.7832426c-.5085938-.1446352-1.0050782-.3013232-1.5015625-.4700642-2.5792969-.8075462-5.50976565-2.0851566-7.62890628-3.7605135-1.22304687-.843705-2.04648437-2.1454212-2.2765625-3.6038255 0-2.2056858 3.8265625-5.0260709 9.34843748-6.9424864.6902344-.2410586 1.3925781-.4580113 2.0949219-.662911.8234375 2.6154853 1.8164062 5.1827589 2.9667969 7.6656621-1.1625 2.5190619-2.1675782 5.1224943-3.003125 7.7741385zm14.1195312 11.8118692c-1.9980469 1.8199922-4.3109375 3.2663435-6.8296875 4.2546836-1.3441406.6388052-2.8941406.6990698-4.2746094.156688-1.9253906-1.1088693-2.7246093-5.3635529-1.6347656-11.0886936.1332031-.6749639.2785156-1.3499279.4480469-2.0128389 2.7125.5785405 5.4492187.9762871 8.2222656 1.1811869 1.5984375 2.2538975 3.3542969 4.4113716 5.23125 6.4362635-.3875.3736407-.775.7352286-1.1625 1.0727105zm2.9667969-2.9288614c-1.2351563-1.3258221-2.4703125-2.7962793-3.6691406-4.3752128 1.1625.0482117 2.3613281.0723175 3.5722656.0723175 1.2472656 0 2.4703125-.0241058 3.68125-.0843705-1.1140625 1.5307219-2.3128906 2.9891261-3.584375 4.3872658zm15.8269531 3.6158783c-.1089844 1.4704572-.8355469 2.844491-1.9980469 3.7725665-1.9253906 1.1088693-6.0304687-.337482-10.4625-4.1221014-.5085937-.4339054-1.0171875-.9039696-1.5378906-1.3860867 1.8527344-2.0369448 3.5601563-4.1944189 5.1101563-6.4603693 2.7730468-.2290056 5.5339843-.6508581 8.2585937-1.2655574.1210938.49417.2300781.9883401.3269531 1.4704572.5933594 2.6034324.6902344 5.3153412.3027344 7.9910911zm2.2039063-12.9568974c-.3390625.1084763-.678125.2169527-1.0292969.3133761-.8476563-2.6275383-1.8890625-5.1948119-3.0878906-7.689768 1.1625-2.4587972 2.1433593-4.9899121 2.9667968-7.5812916.6296875.1807939 1.2351563.3736408 1.8164063.5664876 5.6429687 1.9284685 9.6027344 4.7970653 9.6027344 6.9906982 0 2.3623738-4.2261719 5.4117646-10.26875 7.4004977zM31 32.5172921c3.0636719 0 5.5460937-2.4708502 5.5460937-5.5202409 0-3.0493908-2.4824218-5.520241-5.5460937-5.520241s-5.5460938 2.4708502-5.5460938 5.520241c0 3.0493907 2.4824219 5.5202409 5.5460938 5.5202409z"
        fill="#ffffff"
      />
    </svg>
  );
};

export const NodeJS = ({ className = '', deviceDisplay }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="111"
      height="54"
      viewBox="0 0 111 33"
      fill="none"
      css={{
        transform:
          deviceDisplay === 'isDesktop'
            ? 'scale(1.8) translateX(-10px) translateY(-13px)'
            : 'scale(1.8) translateY(-13px)',
      }}
    >
      <g clipPath="url(#clip0)">
        <path
          d="M97.6896 32.7407C97.4026 32.7407 97.1348 32.6637 96.8861 32.5289L94.3415 31.0081C93.9588 30.7963 94.1501 30.7193 94.2649 30.6808C94.7815 30.5075 94.8772 30.469 95.4129 30.161C95.4703 30.1225 95.5468 30.1418 95.6042 30.1803L97.5557 31.3546C97.6322 31.3931 97.7279 31.3931 97.7853 31.3546L105.419 26.9075C105.496 26.869 105.534 26.792 105.534 26.6958V17.8209C105.534 17.7247 105.496 17.6477 105.419 17.6092L97.7853 13.1814C97.7088 13.1429 97.6131 13.1429 97.5557 13.1814L89.9219 17.6092C89.8454 17.6477 89.8071 17.7439 89.8071 17.8209V26.6958C89.8071 26.7728 89.8454 26.869 89.9219 26.9075L92.0073 28.1204C93.1361 28.6979 93.844 28.0241 93.844 27.3503V18.591C93.844 18.4755 93.9397 18.36 94.0736 18.36H95.0494C95.1642 18.36 95.279 18.4562 95.279 18.591V27.3503C95.279 28.8712 94.4563 29.7567 93.0213 29.7567C92.5813 29.7567 92.2369 29.7567 91.2612 29.2755L89.2523 28.1204C88.7548 27.8316 88.4487 27.2926 88.4487 26.715V17.8402C88.4487 17.2626 88.7548 16.7236 89.2523 16.4348L96.8861 11.9878C97.3644 11.7183 98.0149 11.7183 98.4932 11.9878L106.127 16.4348C106.624 16.7236 106.931 17.2626 106.931 17.8402V26.715C106.931 27.2926 106.624 27.8316 106.127 28.1204L98.4932 32.5674C98.2636 32.6637 97.9766 32.7407 97.6896 32.7407Z"
          fill="#ffffff"
        />
        <path
          d="M100.062 26.6379C96.7137 26.6379 96.0249 25.0978 96.0249 23.7887C96.0249 23.6732 96.1206 23.5577 96.2545 23.5577H97.2494C97.3642 23.5577 97.4598 23.6347 97.4598 23.7502C97.6129 24.7705 98.0529 25.2711 100.081 25.2711C101.688 25.2711 102.377 24.9053 102.377 24.039C102.377 23.5385 102.185 23.1727 99.6792 22.9224C97.5937 22.7106 96.2928 22.2486 96.2928 20.5737C96.2928 19.0144 97.5937 18.0903 99.7748 18.0903C102.224 18.0903 103.429 18.9374 103.582 20.7855C103.582 20.8433 103.563 20.901 103.525 20.9588C103.486 20.9973 103.429 21.0358 103.372 21.0358H102.358C102.262 21.0358 102.166 20.9588 102.147 20.8625C101.918 19.8037 101.325 19.4572 99.7557 19.4572C97.9955 19.4572 97.7851 20.0732 97.7851 20.5352C97.7851 21.0935 98.0338 21.2668 100.406 21.5748C102.759 21.8828 103.869 22.3256 103.869 23.9812C103.869 25.6753 102.472 26.6379 100.062 26.6379Z"
          fill="#ffffff"
        />
        <path
          d="M111.083 17.3202C111.083 18.1288 110.413 18.8026 109.609 18.8026C108.806 18.8026 108.136 18.148 108.136 17.3202C108.136 16.4732 108.825 15.8379 109.609 15.8379C110.394 15.8379 111.083 16.4924 111.083 17.3202ZM108.366 17.3202C108.366 18.0133 108.921 18.5716 109.59 18.5716C110.279 18.5716 110.834 17.994 110.834 17.3202C110.834 16.6272 110.279 16.0882 109.59 16.0882C108.94 16.0882 108.366 16.6272 108.366 17.3202ZM109.055 16.4924H109.629C109.82 16.4924 110.203 16.4924 110.203 16.9352C110.203 17.2432 110.011 17.301 109.896 17.3395C110.126 17.3587 110.145 17.5128 110.164 17.7245C110.183 17.8593 110.203 18.0903 110.241 18.1673H109.896C109.896 18.0903 109.839 17.6668 109.839 17.6475C109.82 17.5513 109.782 17.5128 109.667 17.5128H109.38V18.1865H109.055V16.4924ZM109.361 17.224H109.609C109.82 17.224 109.858 17.07 109.858 16.993C109.858 16.762 109.705 16.762 109.609 16.762H109.342V17.224H109.361Z"
          fill="#ffffff"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.1565 17.4415C18.1565 17.095 17.9652 16.7678 17.6591 16.5945L9.56614 11.8779C9.43221 11.8009 9.27915 11.7624 9.12609 11.7432C9.10696 11.7432 9.04956 11.7432 9.04956 11.7432C8.89651 11.7432 8.74345 11.8009 8.60952 11.8779L0.497439 16.5752C0.191323 16.7485 0 17.0758 0 17.4415L0.0191323 30.0704C0.0191323 30.2437 0.114794 30.4169 0.267852 30.4939C0.42091 30.5902 0.612233 30.5902 0.746159 30.4939L5.56749 27.7217C5.87361 27.5485 6.06493 27.2212 6.06493 26.8747V20.9645C6.06493 20.618 6.25625 20.2907 6.56237 20.1175L8.60952 18.9239C8.76258 18.8276 8.93477 18.7891 9.10696 18.7891C9.27915 18.7891 9.45134 18.8276 9.58527 18.9239L11.6324 20.1175C11.9385 20.2907 12.1299 20.618 12.1299 20.9645V26.8747C12.1299 27.2212 12.3212 27.5485 12.6273 27.7217L17.4104 30.4939C17.5634 30.5902 17.7547 30.5902 17.9078 30.4939C18.0609 30.4169 18.1565 30.2437 18.1565 30.0704V17.4415Z"
          fill="#ffffff"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M57.1479 0.0577539C56.9949 -0.0192513 56.8035 -0.0192513 56.6696 0.0577539C56.5165 0.15401 56.4209 0.308021 56.4209 0.481283V12.9946C56.4209 13.1101 56.3635 13.2256 56.2487 13.3027C56.1339 13.3604 56.0191 13.3604 55.9043 13.3027L53.8763 12.1283C53.5702 11.9551 53.2067 11.9551 52.9005 12.1283L44.7885 16.8449C44.4823 17.0182 44.291 17.3454 44.291 17.6919V27.1058C44.291 27.4524 44.4823 27.7796 44.7885 27.9529L52.9005 32.6695C53.2067 32.8427 53.5702 32.8427 53.8763 32.6695L61.9884 27.9529C62.2945 27.7796 62.4858 27.4524 62.4858 27.1058V3.6385C62.4858 3.27272 62.2945 2.94545 61.9884 2.77219L57.1479 0.0577539ZM56.4017 24.0064C56.4017 24.1026 56.3635 24.1796 56.287 24.2181L53.5128 25.8353C53.4362 25.8738 53.3406 25.8738 53.2641 25.8353L50.4899 24.2181C50.4133 24.1796 50.3751 24.0834 50.3751 24.0064V20.7722C50.3751 20.6759 50.4133 20.5989 50.4899 20.5604L53.2641 18.9433C53.3406 18.9048 53.4362 18.9048 53.5128 18.9433L56.287 20.5604C56.3635 20.5989 56.4017 20.6952 56.4017 20.7722V24.0064Z"
          fill="#ffffff"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M84.1429 20.6951C84.449 20.5218 84.6212 20.1946 84.6212 19.848V17.5571C84.6212 17.2106 84.4299 16.8833 84.1429 16.7101L76.0882 12.0128C75.7821 11.8395 75.4186 11.8395 75.1125 12.0128L67.0004 16.7293C66.6943 16.9026 66.5029 17.2299 66.5029 17.5764V26.9903C66.5029 27.3368 66.6943 27.6641 67.0004 27.8373L75.0551 32.4576C75.3612 32.6309 75.7247 32.6309 76.0117 32.4576L80.8904 29.724C81.0435 29.647 81.1391 29.4737 81.1391 29.3004C81.1391 29.1272 81.0435 28.9539 80.8904 28.8769L72.7401 24.1603C72.587 24.0641 72.4913 23.9101 72.4913 23.7368V20.7914C72.4913 20.6181 72.587 20.4448 72.7401 20.3678L75.2846 18.9047C75.4377 18.8085 75.629 18.8085 75.7821 18.9047L78.3267 20.3678C78.4797 20.4641 78.5754 20.6181 78.5754 20.7914V23.1015C78.5754 23.2748 78.6711 23.448 78.8241 23.525C78.9772 23.6213 79.1685 23.6213 79.3216 23.525L84.1429 20.6951Z"
          fill="#ffffff"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M75.4759 20.2525C75.5333 20.214 75.6099 20.214 75.6673 20.2525L77.217 21.1573C77.2744 21.1958 77.3126 21.2536 77.3126 21.3306V23.1402C77.3126 23.2172 77.2744 23.275 77.217 23.3135L75.6673 24.2183C75.6099 24.2568 75.5333 24.2568 75.4759 24.2183L73.9262 23.3135C73.8688 23.275 73.8306 23.2172 73.8306 23.1402V21.3306C73.8306 21.2536 73.8688 21.1958 73.9262 21.1573L75.4759 20.2525Z"
          fill="#ffffff"
        />
        <path
          d="M31.7207 12.0513C31.4145 11.8781 31.051 11.8781 30.7449 12.0513L22.6902 16.7294C22.3841 16.9027 22.2119 17.2299 22.2119 17.5765V26.9518C22.2119 27.2984 22.4032 27.6256 22.6902 27.7989L30.7449 32.477C31.051 32.6502 31.4145 32.6502 31.7207 32.477L39.7753 27.7989C40.0815 27.6256 40.2536 27.2984 40.2536 26.9518V17.5765C40.2536 17.2299 40.0623 16.9027 39.7753 16.7294L31.7207 12.0513Z"
          fill="#ffffff"
        />
        <path
          d="M39.7946 16.7294L31.7017 12.0513C31.6252 12.0128 31.5295 11.9743 31.453 11.9551L22.3843 27.5679C22.4608 27.6641 22.5565 27.7411 22.6521 27.7989L30.7451 32.477C30.9747 32.6117 31.2425 32.6502 31.4912 32.5732L40.0051 16.9027C39.9477 16.8257 39.8712 16.7679 39.7946 16.7294Z"
          fill="#ffffff"
        />
        <path d="M30.4776 10.3379L30.3628 10.3956H30.5158L30.4776 10.3379Z" fill="#ffffff" />
        <path
          d="M39.7947 27.7991C40.0243 27.6643 40.1965 27.4333 40.273 27.183L31.4147 11.936C31.1852 11.8975 30.9364 11.9167 30.726 12.0515L22.6904 16.7103L31.3573 32.6119C31.4721 32.5926 31.6061 32.5541 31.7209 32.4964L39.7947 27.7991Z"
          fill="#ffffff"
        />
        <path d="M40.5598 27.6446L40.5024 27.5483V27.6831L40.5598 27.6446Z" fill="#ffffff" />
        <path
          d="M39.7952 27.7989L31.7214 32.4769C31.6066 32.5347 31.4918 32.5732 31.3579 32.5924L31.511 32.8812L40.4649 27.6641V27.5486L40.2353 27.1636C40.2162 27.4331 40.044 27.6641 39.7952 27.7989Z"
          fill="#ffffff"
        />
        <path
          d="M39.7952 27.7989L31.7214 32.4769C31.6066 32.5347 31.4918 32.5732 31.3579 32.5924L31.511 32.8812L40.4649 27.6641V27.5486L40.2353 27.1636C40.2162 27.4331 40.044 27.6641 39.7952 27.7989Z"
          fill="#ffffff"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="34.5132"
          y1="15.5354"
          x2="27.1574"
          y2="30.4484"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ffffff" />
          <stop offset="0.3296" stopColor="#ffffff" />
          <stop offset="0.6367" stopColor="#ffffff" />
          <stop offset="0.9341" stopColor="#ffffff" />
          <stop offset="1" stopColor="#ffffff" />
        </linearGradient>
        <linearGradient
          id="paint1_linear"
          x1="30.0088"
          y1="23.3589"
          x2="50.5328"
          y2="8.28841"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1376" stopColor="#ffffff" />
          <stop offset="0.4016" stopColor="#ffffff" />
          <stop offset="0.7129" stopColor="#ffffff" />
          <stop offset="0.9081" stopColor="#ffffff" />
        </linearGradient>
        <linearGradient
          id="paint2_linear"
          x1="21.9174"
          y1="10.3605"
          x2="40.5549"
          y2="10.3605"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0919165" stopColor="#ffffff" />
          <stop offset="0.2871" stopColor="#ffffff" />
          <stop offset="0.5984" stopColor="#ffffff" />
          <stop offset="0.8624" stopColor="#ffffff" />
        </linearGradient>
        <linearGradient
          id="paint3_linear"
          x1="21.9168"
          y1="22.2613"
          x2="40.5549"
          y2="22.2613"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0919165" stopColor="#ffffff" />
          <stop offset="0.2871" stopColor="#ffffff" />
          <stop offset="0.5984" stopColor="#ffffff" />
          <stop offset="0.8624" stopColor="#ffffff" />
        </linearGradient>
        <linearGradient
          id="paint4_linear"
          x1="21.9157"
          y1="27.6148"
          x2="40.5548"
          y2="27.6148"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0919165" stopColor="#ffffff" />
          <stop offset="0.2871" stopColor="#ffffff" />
          <stop offset="0.5984" stopColor="#ffffff" />
          <stop offset="0.8624" stopColor="#ffffff" />
        </linearGradient>
        <linearGradient
          id="paint5_linear"
          x1="21.9174"
          y1="30.0349"
          x2="40.5555"
          y2="30.0349"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0919165" stopColor="#ffffff" />
          <stop offset="0.2871" stopColor="#ffffff" />
          <stop offset="0.5984" stopColor="#ffffff" />
          <stop offset="0.8624" stopColor="#ffffff" />
        </linearGradient>
        <linearGradient
          id="paint6_linear"
          x1="43.2708"
          y1="15.0921"
          x2="31.6606"
          y2="38.6305"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ffffff" />
          <stop offset="0.3296" stopColor="#ffffff" />
          <stop offset="0.6367" stopColor="#ffffff" />
          <stop offset="0.9341" stopColor="#ffffff" />
          <stop offset="1" stopColor="#ffffff" />
        </linearGradient>
        <clipPath id="clip0">
          <rect width="111" height="33" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const AdvancedReactLogo = ({ className = '', deviceDisplay }) => {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width="331.000000pt"
      height="248.000000pt"
      viewBox="0 0 331.000000 248.000000"
      preserveAspectRatio="xMidYMid meet"
      css={{
        transform: deviceDisplay === 'isDesktop' ? 'scale(1)' : 'scale(0.75)',
      }}
    >
      <g
        transform="translate(0.000000,248.000000) scale(0.100000,-0.100000)"
        fill="#ffffff"
        stroke="none"
      >
        <path
          d="M0 2085 l0 -395 65 0 65 0 2 310 3 311 250 -311 250 -310 428 0 428
0 -3 61 -3 60 -272 -1 -273 -1 0 106 0 105 220 0 220 0 0 65 0 65 -220 0 -220
0 0 100 0 100 275 0 275 0 0 65 0 65 -345 0 -345 0 -2 -388 -3 -388 -311 385
-310 386 -87 3 -87 3 0 -396z"
        />
        <path
          d="M1667 2468 c5 -7 148 -185 317 -395 l307 -383 84 0 c47 0 85 2 85 5
0 3 -69 92 -154 197 l-154 191 126 156 c69 86 141 175 160 199 l34 42 -89 0
-89 0 -113 -140 c-62 -77 -115 -140 -119 -140 -4 0 -56 63 -117 140 l-110 139
-89 1 c-69 0 -86 -3 -79 -12z"
        />
        <path
          d="M2620 2415 l0 -65 140 0 140 0 0 -330 0 -330 65 0 65 0 0 330 0 330
135 0 135 0 0 65 0 65 -340 0 -340 0 0 -65z"
        />
        <path
          d="M1805 1874 c-66 -81 -126 -156 -133 -166 -12 -17 -8 -18 76 -18 l89
0 86 109 c48 60 87 113 87 117 0 5 -20 31 -43 58 l-43 48 -119 -148z"
        />
        <path
          d="M2455 1573 c3 -10 45 -133 92 -273 77 -230 104 -293 117 -279 2 2 45
89 95 193 50 104 93 187 95 185 3 -2 46 -87 96 -189 51 -102 94 -187 96 -189
11 -12 31 36 118 292 l95 277 -406 0 c-382 0 -405 -1 -398 -17z"
        />
        <path
          d="M402 1520 c-53 -33 -77 -96 -77 -210 0 -52 3 -118 8 -147 l7 -51 -52
-17 c-143 -47 -260 -137 -274 -212 -19 -103 82 -204 277 -277 l46 -18 -13 -56
c-17 -69 -18 -203 -3 -257 6 -22 28 -56 50 -78 39 -39 39 -39 107 -35 81 4
155 37 244 109 34 27 64 49 68 49 4 0 17 -12 31 -26 13 -14 51 -44 83 -67 120
-82 227 -100 287 -50 67 57 92 181 67 326 l-14 77 40 11 c131 34 264 131 287
208 31 103 -71 210 -274 286 -37 14 -46 22 -42 35 12 37 25 137 25 188 0 77
-18 136 -54 177 -72 83 -194 61 -361 -65 l-67 -51 -37 34 c-135 122 -276 168
-359 117z m184 -70 c33 -16 84 -51 113 -78 l54 -48 -68 -82 c-38 -45 -71 -82
-74 -82 -3 0 -51 -7 -105 -15 -55 -8 -100 -14 -101 -13 -2 2 -8 33 -14 69 -22
132 -10 211 40 253 40 34 81 33 155 -4z m573 6 c33 -18 51 -55 58 -122 5 -50
-11 -178 -26 -202 -6 -10 -29 -9 -109 5 l-101 17 -67 84 c-75 95 -76 88 22
158 103 74 164 90 223 60z m-311 -241 l43 -55 -90 0 c-50 0 -91 3 -91 6 0 8
82 104 89 104 4 0 26 -25 49 -55z m31 -122 c71 -7 72 -8 158 -170 l44 -82 -27
-48 c-15 -26 -47 -80 -71 -119 l-43 -71 -57 -7 c-31 -4 -96 -3 -145 0 -102 8
-92 -1 -178 153 l-53 93 18 37 c38 80 119 203 139 211 26 11 131 12 215 3z
m-362 -88 l-45 -76 -21 56 c-30 81 -30 82 42 92 34 5 63 8 65 7 2 -1 -17 -37
-41 -79z m606 60 c43 -7 47 -9 41 -29 -18 -56 -46 -108 -53 -100 -4 5 -25 40
-46 78 -36 67 -37 69 -14 63 13 -3 46 -9 72 -12z m-729 -115 l37 -100 -38 -95
c-42 -108 -42 -108 -132 -71 -247 100 -240 245 14 339 39 14 73 26 76 26 3 1
22 -44 43 -99z m914 63 c122 -48 202 -116 202 -171 0 -62 -72 -129 -185 -171
-95 -36 -93 -36 -127 54 -41 111 -43 126 -20 171 10 21 27 63 36 92 10 28 20
52 23 52 2 0 35 -12 71 -27z m-792 -326 c23 -39 41 -73 40 -74 -3 -3 -130 18
-135 23 -4 4 43 124 49 124 3 0 24 -33 46 -73z m624 7 c12 -36 20 -67 18 -69
-8 -8 -130 -17 -127 -9 9 20 81 144 84 144 2 0 13 -30 25 -66z m-607 -145 c70
-11 81 -16 99 -43 12 -17 42 -55 67 -85 38 -45 42 -55 30 -65 -8 -6 -35 -28
-60 -48 -55 -46 -144 -88 -184 -88 -76 0 -115 57 -115 165 0 62 11 132 25 174
4 9 14 11 33 8 15 -3 62 -12 105 -18z m664 -64 c24 -131 -3 -243 -63 -265 -40
-16 -65 -12 -129 19 -54 25 -165 113 -165 129 0 4 23 33 50 65 28 32 56 67 63
78 10 14 37 22 103 33 132 20 127 23 141 -59z m-329 27 c-7 -11 -28 -36 -47
-57 l-34 -39 -24 30 c-13 16 -33 41 -44 57 l-20 27 91 0 c87 0 90 -1 78 -18z"
        />
        <path
          d="M725 1001 c-140 -63 -138 -251 3 -313 130 -58 270 63 232 201 -14 52
-45 90 -94 112 -52 23 -90 23 -141 0z"
        />
        <path
          d="M2553 945 c-85 -37 -94 -161 -14 -208 79 -47 181 10 181 100 0 41
-35 92 -75 109 -42 17 -51 17 -92 -1z"
        />
        <path
          d="M3063 944 c-80 -40 -90 -141 -21 -199 28 -24 39 -27 82 -22 42 4 55
10 78 38 53 63 30 153 -48 185 -42 18 -51 17 -91 -2z"
        />
        <path
          d="M2004 916 c-29 -29 -34 -41 -34 -81 0 -40 5 -52 34 -81 29 -29 41
-34 79 -34 84 0 144 80 114 152 -21 51 -61 78 -114 78 -38 0 -50 -5 -79 -34z"
        />
        <path
          d="M2795 813 c-13 -67 -50 -117 -105 -145 -29 -16 -68 -28 -86 -28 -28
0 -39 -8 -79 -60 -71 -93 -187 -180 -282 -214 -41 -14 -43 -14 -82 15 -67 48
-95 100 -99 185 -4 63 -7 74 -24 80 -11 3 -24 2 -28 -3 -19 -18 -72 -160 -87
-227 -53 -256 125 -415 378 -337 37 12 142 57 235 100 200 94 267 117 394 136
119 18 151 28 206 60 81 47 121 127 110 218 -10 78 -16 83 -65 63 -53 -21 -96
-20 -146 3 -54 25 -84 60 -106 123 l-18 53 -55 3 c-54 3 -56 2 -61 -25z"
        />
      </g>
    </svg>
  );
};
